export class AutocompleteToken {

}
